var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-progress-linear',{staticClass:"progress-linear",attrs:{"indeterminate":true,"color":_vm.color,"height":"4"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }